import type { SessionResponse } from "@numbet/protocol";

const SESSION_PREFIX = "numbet:session:";
const NAME_KEY = "numbet:name";
const AVATAR_KEY = "numbet:avatar";

// localStorage kann in privaten Fenstern fehlen oder Ausnahmen werfen.
function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // ohne Speicher geht die Sitzung beim Neuladen verloren – das Spiel funktioniert trotzdem
  }
}

export function loadSession(code: string): SessionResponse | null {
  const raw = read(SESSION_PREFIX + code);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SessionResponse;
  } catch {
    return null;
  }
}

export function saveSession(session: SessionResponse): void {
  write(SESSION_PREFIX + session.code, JSON.stringify(session));
}

export function clearSession(code: string): void {
  write(SESSION_PREFIX + code, null);
}

export function loadName(): string {
  return read(NAME_KEY) ?? "";
}

export function saveName(name: string): void {
  write(NAME_KEY, name);
}

export function loadAvatar(): string {
  return read(AVATAR_KEY) ?? "initials";
}

export function saveAvatar(avatar: string): void {
  write(AVATAR_KEY, avatar);
}
